import { useSetLiveMerge } from "@/Pages/Auth/Bestellingen/Live/useIsLiveMerge";
import { Jwt } from "@/shared/utils/interfaces";
import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useAtom, useSetAtom } from "jotai";
import { useEffect, useMemo } from "react";
import { JWTAtom, lastestVersionModal } from "../atoms/index";
import { useSetBranch } from "../atoms/useBranch";
import useFranchiseHook from "./useFranchiseHook";
import useMerchantHook from "./useMerchantHook";

const useAuthHook = () => {
  const setVersionModal = useSetAtom(lastestVersionModal);
  const setLiveMerge = useSetLiveMerge();
  const setBranch = useSetBranch();
  const [, setFranchise] = useFranchiseHook();
  const [, setMerchant] = useMerchantHook();
  const [atom, setAtom] = useAtom(JWTAtom);
  const jwt: Jwt | boolean = useMemo(() => JSON.parse(atom), [atom]);
  const queryClient = useQueryClient();

  useEffect(() => {
    window.dispatchEvent(new Event("jwtStorage"));
  }, [jwt]);

  const setJWT = (value: any) => {
    setAtom(
      JSON.stringify(
        value === false
          ? value
          : {
              ...value,
              last_login: dayjs(new Date()),
            }
      )
    );
  };

  const signOut = () => {
    queryClient.removeQueries(); // Removes all queries
    queryClient.clear();
    setJWT(false);
    setBranch(null);
    setFranchise(-1);
    setMerchant(-1);
    setVersionModal({ show: false, data: [], isShown: false });
    setLiveMerge(true);
    localStorage.clear();
  };

  const isAuth = useMemo(() => (jwt === false ? false : true), [jwt]);

  return { jwt, setJWT, isAuth, signOut };
};

export default useAuthHook;
